import {
    CUSTOMERS_SUCCESSFUL_FETCH,
    CUSTOMERS_SUCCESSFUL_SAVE,
    SHOW_ERROR_MESSAGE
} from 'reducers/constants';

import HttpClient from "utils/HttpClient/HttpClient"
import {AFILIATE_SUCCESSFUL_FETCH, AFILLIATE_SUCCESSFUL_FETCH} from "../constants";

export const fetchCustomers = (searchCriteria, resolve, reject) => dispatch => {
    new HttpClient(true).get("oga/customers",
        {
            params: {
                searchCriteria: searchCriteria
            }
        })
        .then((response) => {
            dispatch({
                type: CUSTOMERS_SUCCESSFUL_FETCH,
                payload: response.data
            });
            resolve();
        })
        .catch((error) => {
            dispatch({
                type: SHOW_ERROR_MESSAGE,
                payload: error.message
            });
            reject();
        });
}

export const saveCustomerPerson = (customer, issuedPlace, dpt, resolve, reject) => dispatch => {
    new HttpClient(true).post("oga/customers/prospect/person?issuedPlace="+issuedPlace+"&dpt="+dpt, customer)
        .then((response) => {
            console.log("Successful Save Customer");
            dispatch({
                type: CUSTOMERS_SUCCESSFUL_SAVE,
                payload: response.data
            });
            resolve("Successful");
        })
        .catch((error) => {
            console.log("Failed Save Customer");
            dispatch({
                type: SHOW_ERROR_MESSAGE,
                payload: error.response.data.message
            });
            reject("Failed");
        })
}





// WEBPACK FOOTER //
// ./src/reducers/customer/customerActions.js